/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SwatchSelector_transactions$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedSwatchSelector_transactions$ref: FragmentReference;
export type PdpSharedSwatchSelector_transactions = {|
  +$fragmentRefs: SwatchSelector_transactions$ref,
  +$refType: PdpSharedSwatchSelector_transactions$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedSwatchSelector_transactions",
  "type": "TransactionConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SwatchSelector_transactions",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5d0679382d998eb227bba03ec7713961';
module.exports = node;
